import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { VssEvent } from 'src/app/shared/models/vss-event.module';
import { environment } from 'src/environments/environment';

export class EventType {
  id: number;
  name_it: string;
  name_de: string;
  name_en: string;
  status: number;
}

@Injectable({
  providedIn: 'root'
})
export class VssEventsService {

  constructor(private _http: HttpClient) { }

  public getVssOrganizationEvents(orgId: string, eventId?: number): Observable<VssEvent[] | VssEvent> {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    // VssOrganization
    return this._http.get<VssEvent[]>(environment.serverUrl + 'vss/event/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return (!eventId ? responseData : responseData.filter(r => r.id.toString() === eventId.toString())[0]);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public updateVssOrganizationEvent(event: VssEvent): Observable<any> {
    return this._http.post<any>(environment.serverUrl + 'vss/event/update', { event }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public createVssOrganizationEvent(event: VssEvent): Observable<any> {
    return this._http.put<any>(environment.serverUrl + 'vss/event/create', { event }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * submitOrganizationImage
   */
  public submitEventImage(file: File, orgId: number) {
    const formData = new FormData();
    formData.append('id', orgId.toString());
    formData.append('image', file, file.name);
    return this._http.post<any>(
      environment.serverUrl + 'vss/event/upload',
      formData
    ).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public getVssEventTypes(): Observable<EventType[]> {
    return this._http.get<EventType[]>(environment.serverUrl + 'vss/eventType/get').pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public deleteVssEvent(eventId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', eventId.toString());
    return this._http.delete<void>(environment.serverUrl + 'vss/event/delete', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public deleteVssEventImage(imageId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', imageId.toString());
    return this._http.delete<void>(environment.serverUrl + 'vss/event/deleteFile', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
  public setMainEventImage(id: number): Observable<any> {
    return this._http.post<any>(environment.serverUrl + 'vss/event/mainImage', { id }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
